import { useEffect, useState } from "react";
import { Calendar, ArrowRight } from "lucide-react";
import PageHeader from "../components/site/PageHeader";
import { api } from "../lib/api";

export default function News() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page">
      <PageHeader
        eyebrow="Duyurular & Haberler"
        title="Kulüp Gündemi"
        subtitle="Açılış haberleri, yeni branşlar, etkinlik duyuruları ve antrenör katılımları — Focus Spor Kulübü'nden son gelişmeler."
      />

      <section className="section-pad">
        <div className="container-x">
          <div className="grid lg:grid-cols-3 gap-5">
            {items.map((a) => (
              <article
                key={a.id}
                className="card-elev p-6 flex flex-col cursor-pointer"
                onClick={() => setActive(a)}
                data-testid={`news-card-${a.id}`}
              >
                <div className="flex items-center gap-2 text-xs font-display uppercase tracking-[0.2em] text-muted-foreground mb-4">
                  <Calendar className="h-3.5 w-3.5 text-primary" />
                  {a.date}
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight">{a.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-3">{a.excerpt}</p>
                <span className="mt-auto pt-5 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-primary">
                  Devamını Oku <ArrowRight className="h-3 w-3" />
                </span>
              </article>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-background/95 backdrop-blur-md p-4 sm:p-8 overflow-y-auto"
          onClick={() => setActive(null)}
          data-testid="news-modal"
        >
          <article
            onClick={(e) => e.stopPropagation()}
            className="relative max-w-2xl mx-auto card-elev p-6 md:p-10 mt-10"
          >
            <button
              type="button"
              onClick={() => setActive(null)}
              className="absolute top-4 right-4 text-muted-foreground hover:text-primary"
              data-testid="news-modal-close"
            >
              ✕
            </button>
            <div className="flex items-center gap-2 text-xs font-display uppercase tracking-[0.2em] text-muted-foreground mb-3">
              <Calendar className="h-3.5 w-3.5 text-primary" />
              {active.date}
            </div>
            <h2 className="heading-md mb-5">{active.title}</h2>
            <p className="text-muted-foreground leading-relaxed whitespace-pre-line">{active.body}</p>
          </article>
        </div>
      )}
    </div>
  );
}
